export default __webpack_public_path__ + "assets/images/e126359165b80db5ddcec21d6dab788f.svg";